
import React from 'react';
import { withRouter } from 'react-router-dom';
import Axios from 'axios';
import '../../../../../SCSS/workExp.scss';
import AddIcon from '@material-ui/icons/Add';
import AddCircleIcon from "../../../../../Assets/icons/add_circle.png"
// import AddCircleIcon from '../../../../../../assets/images/add_circle.png'
import RemoveCircleIcom from '../../../../../Assets/icons/remove_circle.png'

class WorkExperience extends React.Component {
    constructor(props) {
        super(props);
        this.state = {


        }
    }



    render() {
        return (<React.Fragment >
            <div className="table-wrapper">
                <table className="zq-table-wrap">
                    <thead className="zq-table-heading">
                        <tr>
                            <th> S.No.</th>
                            <th>Company Name</th>
                            <th>Designation</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Remarks</th>
                            <th>Attachments</th>
                        </tr>

                    </thead>
                    <tbody className="zq-table-body">
                        <tr>
                            <td>1</td>
                            <td><input type="text" className="table-input-border" value="Snipe Technologies LLP" /></td>
                            <td><input type="text" className="table-input-border" value="Technology" /></td>
                            <td><input type="text" className="table-input-border" value="01/12/2018" /></td>
                            <td><input type="text" className="table-input-border" value="01/12/2019" /></td>
                            <td>
                                <input type="text" className="table-input-border" value="01/12/2019" />
                            </td>
                            <td>Employee.pdf</td>
                            <td><img src={AddCircleIcon} style={{ width: '25px', height: '25px' }} /></td>
                            <td><img src={RemoveCircleIcom} style={{ width: '25px', height: '25px' }} /></td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </React.Fragment >)
    }
}
export default WorkExperience;